import apiClient from './apiClient';

// ============================================================
// Types -- matching backend Go models
// ============================================================

export interface F11K {
  f11k_01: string;        // 員工簡碼（1=業務,2=採購,3=實驗室,4=人事,5=業務&採購）
  f11k_11: string;        // 員工代號
  f11k_12: boolean;       // 是否為組長
  f11k_13: boolean;       // 舊代號旗標
  f11k_14: string;        // 業別類型（1-5）
  f11k_91: string;        // 建立者代號
  f11k_92: string | null; // 建立日期
  f11k_93: string;        // 修改者代號
}

export interface CreateRequest {
  f11k_01: string;
  f11k_11: string;
  f11k_12: boolean;
  f11k_13: boolean;
  f11k_14: string;
}

export interface UpdateRequest {
  f11k_12: boolean;
  f11k_13: boolean;
  f11k_14: string;
}

export interface ListResponse {
  data: F11K[];
  total: number;
  page: number;
  size: number;
}

export interface ValidationError {
  field: string;
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const empShortcodeApi = {
  async list(page = 1, size = 100, keyword?: string): Promise<ListResponse> {
    const params: Record<string, string | number> = { page, size };
    if (keyword) params.keyword = keyword;
    const res = await apiClient.get('/api/emp-shortcode', { params });
    return res.data;
  },

  async get(code: string, empId: string): Promise<F11K> {
    const res = await apiClient.get(`/api/emp-shortcode/${encodeURIComponent(code)}/${encodeURIComponent(empId)}`);
    return res.data;
  },

  async create(data: CreateRequest): Promise<F11K> {
    const res = await apiClient.post('/api/emp-shortcode', data);
    return res.data;
  },

  async update(code: string, empId: string, data: UpdateRequest): Promise<F11K> {
    const res = await apiClient.put(`/api/emp-shortcode/${encodeURIComponent(code)}/${encodeURIComponent(empId)}`, data);
    return res.data;
  },

  async delete(code: string, empId: string): Promise<void> {
    await apiClient.delete(`/api/emp-shortcode/${encodeURIComponent(code)}/${encodeURIComponent(empId)}`);
  },
};
